define('v3/Common/Bindings/Progress.Binding',['jquery', 'knockout', 'lodash'], function ($, ko, _) {
	var setSize = function (element, values) {
		if (!values && (!values.value || !values.highest)) {
			return;
		}

		var length = String(values.highest + values.suffix).split('').length;
		var textWidth = length * 8; // 8 = char width
		var totalWidth = $(element).width() - textWidth;

		$(element)
			.find('.ability-target-container')
			.css('flex-basis', totalWidth * (values.value / values.highest));
	};

	ko.bindingHandlers.progress = {
		init: function (element, valueAccessor) {
			var values = valueAccessor();
			values.suffix = values.suffix || '';
			var id = _.uniqueId();

			$(element).addClass('progress').html('' +
				'<div class="ability-target-container">' +
					'<div class="ability-target-bar">' +
						'<div class="actual-growth"></div>' +
					'</div>' +
				'</div>' +
				'<div class="text">' + values.value + values.suffix + '</div>');

			ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
				$(window).off('resize.progress' + id);
			});

			$(window).on('resize.progress' + id, _.debounce(function () {
				setSize(element, values);
			}, 300));
		},
		update: function (element, valueAccessor) {
			var values = valueAccessor();
			values.suffix = values.suffix || '';

			setSize(element, values);
		}
	};
});

